import styles from "./ServicesPage.module.scss";
import useAppSelector from "../../hooks/useAppSelector";
import Spinner from "../../components/Spiner/Spinner";
import {getImageFromAuthServer} from "../../helpers/image.helper";
import ServiceModal from "./ServiceModal/ServiceModal";
import {useState} from "react";
import {IPublicTrainingCourse} from "../../models/TrainingCourse";

const ServicesPage = () => {


    const {isClassesLoading, visibleClasses} = useAppSelector(state => state.classesSlice);
    const [currentItem, setCurrentItem] = useState<null | IPublicTrainingCourse>(null);

    const closeModal = () => {
        setCurrentItem(null);
    }

    if (isClassesLoading) {
        return (
            <Spinner/>
        )
    }

    if (visibleClasses.length === 0 && !isClassesLoading) {
        return (
            <>
                Empty
            </>
        )
    }

    return (
        <section className={styles.page}>
            <div className={"container"}>
                <div className={styles.wrapper}>
                    {visibleClasses.map((el, index) => {
                        return (
                            <div
                                key={el.id}
                                onClick={() => setCurrentItem(el)}
                                className={`${styles.item} ${visibleClasses.length % 2 !== 0 && index === 0 ? styles.fullScreen : styles.halfScreen}`}
                                style={{backgroundImage: `url(${getImageFromAuthServer(el.image)})`}}
                            >
                                <span className={`${styles.label} ${index % 2 === 0 && index !== 0 && styles.bottomLabel}`}>{el.name}</span>
                            </div>
                        )
                    })}
                </div>
            </div>
            {
                currentItem && (
                    <ServiceModal
                        item={currentItem}
                        closeModalFn={closeModal}
                    />
                )
            }

        </section>
    )
}

export default ServicesPage;